    <template>
      <div>
        <!-- {{ userList }} -->
        <el-table :data="userList" height="calc(100vh - 360px)">
          <el-table-column prop="tenantName" label="租户名称" fixed="left" align="center" />
          <el-table-column prop="channelUserId" fixed="left" label="合伙人UID" width="120" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.channelUserId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="节点总净盈亏(USDT)" width="170">
            <template slot-scope="scope">{{ scope.row.profit }}</template>
          </el-table-column>

          <el-table-column prop="profitAmount" label="节点总盈亏(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.profitAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalFee" label="节点总手续费(USDT)" align="center" width="170">
            <template slot-scope="scope">
              {{ scope.row.totalFee }}
            </template>
          </el-table-column>

          <el-table-column label="节点总净充值(USDT)" width="170">
            <template slot-scope="scope">{{ scope.row.recharge }}</template>
          </el-table-column>
          <el-table-column label="节点总出金(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.txAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="节点总入金(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="节点法币总入金(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.otcRecharge }}</span>
            </template>
          </el-table-column>
          <el-table-column label="节点法币总出金" prop="otcWithdraw" width="170" />
          <el-table-column prop="totalContractFee" label="合约汇总手续费(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.totalContractFee }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalSpotFee" label="现货汇总手续费(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.totalSpotFee }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contractRate" label="合约比例" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.contractRate }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="spotRate" label="现货比例" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.spotRate }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="deductContractFee" label="合约扣减手续费(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.deductContractFee }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deductSpotFee" label="现货扣减手续费(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.deductSpotFee }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualContractFee" label="合约实际手续费(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.actualContractFee }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualSpotFee" label="现货实际手续费(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.actualSpotFee }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deductContractRebate" label="合约扣减返佣(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.deductContractRebate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deductSpotRebate" label="现货扣减返佣(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.deductSpotRebate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualContractRate" label="合约实际返佣(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.actualContractRate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualSpotRate" label="现货实际返佣(USDT)" width="170">
            <template slot-scope="scope">
              <span>{{ scope.row.actualSpotRate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="110">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="goToRebateDetail(scope.row)">
                查看明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag">
          <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
          </pagination>
        </div>

        <!-- <update-dialog
          :val="userinfoDetail"
          :updateForm="updateForm"
        ></update-dialog> -->

        <!-- 编辑用户信息dialog -->
        <!-- <el-dialog
          title="修改备注"
          :visible.sync="centerDialogVisible"
          width="30%"
          center
        >
          <div class="main">
            <el-card class="box-card">
              <div>备注信息</div>
              <div class="content">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入备注信息"
                  maxlength="50"
                  show-word-limit
                  v-model="textarea2"
                >
                </el-input>
              </div>
              <div class="btn">
                <el-button size="small" type="primary" @click="add"
                  >添 加</el-button
                >
              </div>
            </el-card>
          </div>
      
        </el-dialog> -->
      </div>
    </template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";
import { BackgroundColor } from "@icon-park/vue";

export default {
  name: "UserList",
  props: {
    tenantId: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: "",
    };
  },
  components: {
    Pagination,
    updateDialog,
  },
  methods: {
    ...mapActions("funds", ["addRemark"]),
    ...mapMutations("funds", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
      "setPagination",
    ]),
    goToRebateDetail(row) {
      let startTime, endTime;
      if (this.value1 && this.value1.length > 0) {
        startTime = this.value1[0];
        endTime = this.value1[1];
      }
      const channelUserId =
        row && row.channelUserId != null ? String(row.channelUserId) : "";
      console.log('tenantId', this.tenantId);
      this.$router.push({
        path: "/home/funds/rebate-detail",
        query: {
          channelUserId,
          startTime,
          endTime,
          type: 1,
          tenantId: this.tenantId,
        },
      });
    },
    tableRowClassName() {
      // return { 'background-color': '#67c23a','border':'1px solid red' }
      return "rowClassName";
    },
    rowClass() {
      // return 'background:#E6F1FF;color:#368CFF;font-size:13px'
      " color: #2AFCFD ; background: #f5f6f9;";
      // return " border-top: 1px solid #1753ac;border-bottom: 1px solid #1753ac; background: rgba(16, 37, 118, 0.5);";
    },
    headClass() {
      // return " color: #2AFCFD ; background: #f5f6f9;";
    },

    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleUpdate(row) {
      this.updateForm = row;
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true;
      this.textarea2 = row.remarks;
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("添加成功");
          (this.textarea2 = ""), (this.centerDialogVisible = false);
          this.$emit("refresh");
        }
        if (res.code == 1) {
          this.$message.error(res.error.msg);
        }
      });
    },
  },
  computed: {
    // ...mapGetters('funds', ['userList']),
    ...mapState(["userInfo"]),
    ...mapState("funds", [
      "pagination",
      "userList",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" src="../../../../styles/table.less" scoped>
.pag {
  display: flex;
  justify-content: center;
}

.user-type-select {
  width: 100%;
}

.red {
  color: skyblue;
  font-weight: bold;
}

.cc {
  color: #97a0ff;
  font-weight: bold;
}

::v-deep .el-dialog__title {
  color: #6767b3;
  font-size: 24px;
}

::v-deep.el-dialog__headerbtn {
  font-size: 26px;
}

::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;

  .main {
    width: 100%;
    position: relative;

    .box-card {
      width: 100%;
      height: 260px;

      .el-card__body {
        height: 86%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .el-textarea {
          box-shadow: 0px 0px 1px rgba(24, 26, 32, 0.1),
            0px 3px 6px rgba(71, 77, 87, 0.04),
            0px 1px 2px rgba(24, 26, 32, 0.04);
        }

        .el-textarea__inner {
          padding: 18px 16px;
        }

        .btn {
          display: flex;
          justify-content: center;

          .el-button--primary {
            width: 156px;
            height: 37px;
            background: #707aff;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

::v-deep .el-dialog--center {
  margin-top: 5vh;
  width: 468px;
  // height: 557px;
  background: #f5f6ff;
  border-radius: 8px;
}

// ::v-deep .el-table__body{
//   //-webkit-border-horizontal-spacing: 13px;  // 水平间距
//   -webkit-border-vertical-spacing: 8px;  // 垂直间距
// }
// ::v-deep.el-table th {
//   font-weight: bold;
//   color: #909399;
//   border: none;
// }
// ::v-deep.el-table__header {
//   background-color: #f4f6fa;
// }

// .el-table th, .el-table tr {
//     background-color: #909399;
// }
// ::v-deep.el-table td,
// .el-table th.is-leaf {
//   background-color: #f5f6f9;
//   border: none;
//   outline: none;
//   margin-bottom: 5px;
//   &:nth-child(1) {
//     border-top-left-radius: 12px;
//     border-bottom-left-radius: 12px;
//   }
//   &:nth-last-child(1) {
//     border-top-right-radius: 12px;
//     border-bottom-right-radius: 12px;
//   }
// }
// .el-table::before {
//     left: 0;
//     bottom: 0;
//     width: 100%;
//     height: 0px;
// }</style>
